function escapeHtmlText(text: string) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function formatHtmlParagraph(text: string) {
    if (!text)
        return '<p><em>-</em></p>';

    return `<p>${escapeHtmlText(text).replace(/\n/g, '<br/>')}</p>`;
}

function formatHtmlSection(title: string, content: string) {
    return `<p><strong>${escapeHtmlText(title)}</strong></p>${formatHtmlParagraph(content)}`;
}

const YODA_CONTEXT_MAX_LENGTH = 2000;

export const getUserEnvironmentInfo = () => {
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const mobileDevice = isMobile ? "Yes" : "No";
    const browserVersion = userAgent.match(/(firefox|msie|chrome|safari|trident)\/\d+/i)?.[0] || 'Unknown Version';
    const windowSize = `${window.innerWidth}x${window.innerHeight}`;
    const cookiesEnabled = navigator.cookieEnabled ? "Yes" : "No";
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        userAgent,
        language,
        screenResolution,
        browserInfo: userAgent.match(/(firefox|msie|chrome|safari|trident)/i)?.[0] || 'Unknown Browser',
        osInfo: userAgent.match(/(windows nt|mac os x|linux|ubuntu)/i)?.[0].replace(/_/g, '.') || 'Unknown OS',
        mobileDevice,
        browserVersion,
        windowSize,
        cookiesEnabled,
        timezone
    };
};

/**
 * Parse the `yodaContext` URL query parameter from a host app.
 * Accepts a compact JSON object of flat primitive values; ignores invalid / oversized payloads.
 */
export function getHostYodaContextFromSearchParams(searchParams: URLSearchParams): Record<string, string | number | boolean> {
    const param = searchParams.get('yodaContext');
    if (!param || param.length > YODA_CONTEXT_MAX_LENGTH) {
        return {};
    }

    try {
        const parsed = JSON.parse(param);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return {};
        }

        const result: Record<string, string | number | boolean> = {};
        for (const [key, value] of Object.entries(parsed)) {
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                const flatKey = key.startsWith('host') ? key : `host${key.charAt(0).toUpperCase()}${key.slice(1)}`;
                result[flatKey] = value;
            }
        }
        return result;
    } catch {
        return {};
    }
}

/**
 * Merge host context under browser env so browser keys are never overwritten.
 */
export function mergeEnvironmentWithHostContext(
    browserEnv: AnyObj,
    hostContext: Record<string, string | number | boolean>
): AnyObj {
    return {
        ...hostContext,
        ...browserEnv,
    };
}

export const formatBugReportDescription = (change: AnyObj) => (
    formatHtmlSection('Description', change.description) +
    formatHtmlSection('Étapes pour reproduire', change.steps) +
    formatHtmlSection('Résultat attendu', change.expectedResult) +
    formatHtmlSection('Résultat réel', change.actualResult)
);

export const formatEnvironmentTechnicalContext = (userEnvInfo: AnyObj) => ({
    environment: userEnvInfo
});
